export enum StorageKey {
  ACCESS_TOKEN = "accessToken",
  REFRESH_TOKEN = "refreshToken",
  PUBLIC_KEY = "publicKey",
  BALANCE = "balance",
  DEPOSIT = "deposit"
}

export enum SessionToken {
  ACCESS = "accessToken",
  REFRESH = "refreshToken"
}
